import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject, takeUntil } from "rxjs";
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ProductsService } from 'src/app/inventory/products/products.service';
import { AccountsTransactionType, TransactionNames } from 'src/app/finance/constants/constants';
import { UtilityService } from 'src/app/inventory/products/utility/utility.service';

@Component({
  selector: 'app-item-history',
  templateUrl: './item-history.component.html',
  styleUrls: ['./item-history.component.scss']
})
export class ItemHistoryComponent {

  @Input() historyCols = [];
  @Input() historyData = [];
  @Input() trackingOptions  =[];
  @Input() selectedProduct = null;
  @Input() noHistoryFindOrLoadingText: string = '';
  noTrackingFindOrLoadingText: string = 'Loading..';
  totalTBRecord: number = 0;
  txnRowData;
  pageTBNumber: number = 1;
  pageSize: number = 15;
  rowsPerPage = [15, 30, 50, 100];
  trackingProducts = [];
  displayTrackingDetails: boolean = false;
  // invoice 
  displayInventoryOverview: boolean = false;
  inventoryOverviewRefId: number = 0;
  inventoryOverviewRefNumber: string = "";
  inventoryOverviewModule: string = "";
  // write check
  displayWriteCheck: boolean = false;
  overviewRefId: number = 0;
  //Expense
  displayAddEditExpense: boolean = false;
  //  credit charges
  displayCreditCardViewDialog: boolean = false;
  // invetory adjustment
  displayAdjustment: boolean = false;
  inventoryAdjustmentId: number = 0;
  isView: boolean = true;
  // inventory transfer
  displayTransfer: boolean = false;
  inventorytransferId: number = 0;
  @Output() openLocationDialog = new EventEmitter<number>();
  utilService: UtilityService;
  trackingSelectOption = null;

  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(private app: AppMainComponent, private appMainService: AppMainService, private productsService: ProductsService,
    private utilityService: UtilityService
  ) { 
    this.utilService = this.utilityService;
  }


  loadTrackingOptionsOrg(data) {
    this.productsService.loadTrackingOptions().pipe(takeUntil(this.ngUnsubscribe$)).subscribe((options) => {
      this.trackingOptions = options;
      this.openTracking(data);
    })
  }

  openTracking(data) {
    this.txnRowData = data;
    this.appMainService.isShowSpinner('serials');
    this.productsService.getTransactionTracking(this.pageTBNumber, this.pageSize, this.selectedProduct?.id, data.transNumber, data.transType)
      .then((serials) => {
        let { tracking, headers } = serials;
        tracking = tracking ?? [];
        headers = headers ?? [];
        this.totalTBRecord = headers["TotalCount"];
        this.trackingProducts = [];
        this.trackingSelectOption = tracking?.item3 ? JSON.parse(tracking.item3) : null;
        if (tracking?.item2.length > 0) {
          for (let data of tracking.item2) {
            data.expirationDate = (data.expirationDate ? this.app._showDateTimeWithZone(data.expirationDate) : null);
          }
          this.trackingProducts = tracking.item2;
          this.appMainService.isHideSpinner('serials');
        } else {
          this.noTrackingFindOrLoadingText = "No Serials Details found.";
          this.trackingProducts = [];
          this.appMainService.isHideSpinner('serials');
        }
        this.displayTrackingDetails = true;
      })
      .finally(() => {
        this.noTrackingFindOrLoadingText = "No Serials Details found.";
        this.appMainService.isHideSpinner('serials');
      });
  }

  getTxnTrackingData(event) {
    this.pageTBNumber = event.first / event.rows + 1;
    this.pageSize = event.rows;
    this.openTracking(this.txnRowData);
  }
  detailsView(rowData, str) {
    if (str == 'locationID') {
      this.openLocationDialog.emit(rowData.warehouseId);
      return
    }
    const AccTranKey = this.findTransactionType(AccountsTransactionType, rowData.transType);
    if (AccTranKey == 'SalesReturn') {
      this.inventoryOverviewModule = TransactionNames.CreditMemo;
    } else if (AccTranKey == 'ReceivePayment') {
      this.inventoryOverviewModule = TransactionNames.Invoice;
    }
    else {
      this.inventoryOverviewModule = TransactionNames[AccTranKey];
    }

    if (this.inventoryOverviewModule == TransactionNames.Invoice) {
      this.inventoryOverviewRefId = rowData.referenceId
      this.inventoryOverviewRefNumber = rowData.txnid
      this.displayInventoryOverview = true;
    } else if (this.inventoryOverviewModule == TransactionNames.CreditMemo) {
      this.inventoryOverviewRefId = rowData.referenceId
      this.inventoryOverviewRefNumber = rowData.txnid
      this.displayInventoryOverview = true
    } else if (this.inventoryOverviewModule == TransactionNames.CustomerRMA ||
      this.inventoryOverviewModule == TransactionNames.ItemReceipt) {
      this.inventoryOverviewRefId = rowData.referenceId;
      this.inventoryOverviewRefNumber = rowData.txnid;
      this.displayInventoryOverview = true;
    } else if (this.inventoryOverviewModule == TransactionNames.Bill) {
      this.inventoryOverviewRefNumber = rowData.txnid
      this.inventoryOverviewRefId = rowData.referenceId
      this.displayInventoryOverview = true;
    } else if (this.inventoryOverviewModule == TransactionNames.Check) {
      this.overviewRefId = rowData.referenceId
      this.displayWriteCheck = true;
    } else if (this.inventoryOverviewModule == TransactionNames.Expense) {
      this.overviewRefId = rowData.referenceId
      this.displayAddEditExpense = true;
    } else if (this.inventoryOverviewModule == TransactionNames.CreditCharges) {
      this.overviewRefId = rowData.referenceId
      this.displayCreditCardViewDialog = true;
    } else if (this.inventoryOverviewModule == TransactionNames.InventoryAdjustment) {
      this.inventoryAdjustmentId = rowData.referenceId
      this.displayAdjustment = true;
    } else if (this.inventoryOverviewModule == TransactionNames.InventoryTransfer) {
      this.inventorytransferId = rowData.referenceId
      this.displayTransfer  = true;
    } else if (this.inventoryOverviewModule === TransactionNames.VendorRMA ||
      this.inventoryOverviewModule === TransactionNames.VendorCredit) {
      this.inventoryOverviewRefNumber = rowData.txnid;
      this.inventoryOverviewRefId = rowData.referenceId;
      this.displayInventoryOverview = true;
    }
  }

  findTransactionType(obj, value) {
    return Object.keys(obj).find(key => obj[key] === value);
  }
  // invoice 
  closeViewPopup() {
    this.displayInventoryOverview = false;
  }
  onCloseWriteCheckDialog(e) {
    this.overviewRefId = 0;
    this.displayWriteCheck = false;
  }
  onCloseExpenseDialog(e) {
    this.overviewRefId = 0;
    this.displayAddEditExpense = false;
  }
  onCloseCreditChargeDialog(e) {
    this.overviewRefId = 0;
    this.displayCreditCardViewDialog = false;
  }

  onDialogClose() {
    this.displayAdjustment = false;
    this.displayTransfer = false;
  }

}
